/** The two teams of the match, from the parent record, so child blocks can name a side. */
export interface MatchSides {
  homeTeamId?: string | null;
  awayTeamId?: string | null;
  homeName?: string | null;
  awayName?: string | null;
}

/** The name of the side a Mood team id belongs to, or undefined for neither. */
export function sideName(
  sides: MatchSides,
  teamId?: string | null,
): string | undefined {
  if (!teamId) return undefined;
  if (teamId === sides.homeTeamId) return sides.homeName ?? "Home";
  if (teamId === sides.awayTeamId) return sides.awayName ?? "Away";
  return undefined;
}
